module.exports = __webpack_public_path__ + "img/81.fc965b70.png";